import styled, {css} from "styled-components"

import {onePxThick} from "@irati/ui/src/global/elevation"
import {greys} from "@irati/ui/src/global/colors"
import Icon from "@irati/ui/src/Icon"
import IconText from "@irati/ui/src/IconText"
import padding from "@irati/ui/src/global/padding"
import {RouterLink} from "@irati/ui/src/Link"

import Badge from "../Badge"

export const AvatarContainer = styled.div`
  position: relative;
  display: inline-block;
`

interface ContainerProps {
  isDealUnavailable?: boolean,
  isBoostedPerk?: boolean
}

export const Container = styled.div<ContainerProps>`
  font-size: 14px;
  line-height: 16px;
  border-radius: 3px;
  ${onePxThick};
  background-color: ${({theme}) => theme.colors.utility.white};
  cursor: pointer;
  ${({theme, isBoostedPerk}) => isBoostedPerk && `
    background-color: ${theme.colors.secondary2_50};
  `}

  &:hover {
    background-color: ${greys.light};
    ${({theme, isBoostedPerk}) => isBoostedPerk && `
        background-color: ${theme.colors.secondary2_200};
    `}
  }
`

export const StyledBadge = styled(Badge)`
  position: absolute;
  top: 0;
  left: 0;
  transform: translate(-25%, -25%);
`

export const StyledIconText = styled(IconText)`
  white-space: nowrap;

  ${Icon} {
    vertical-align: baseline !important;
    margin-right: 0;
  }
`

export const Row = styled.div`
  margin: 0 -${padding.tiny};
  display: flex;
`

interface ColProps {
  width?: number,
  flex?: string,
  flush?: boolean
}

export const Col = styled.div<ColProps>`
  position: relative;
  padding: 0 ${padding.tiny};
  width: 100%;
`

export const SecondRow = styled(Row)`
  padding-top: 10px;
`

interface StyledRouterLinkProps {
  isDealUnavailable?: boolean
}

export const StyledRouterLink = styled(RouterLink)<StyledRouterLinkProps>`
  padding: 15px;
  display: block;

  &:hover {
    text-decoration: none;
  }

  ${({isDealUnavailable, theme}) => isDealUnavailable && `
    background-color: ${theme.colors.greys.mediumLight}};
  `}
`

export const EmptyWrapper = styled.div`
  padding: 15px;
`

export const NonBoostedValue = styled.span`
  ${({theme}) => css`
    text-decoration: line-through;
    color: ${theme.colors.primary2};
    margin: ${theme.spacing.oneAndHalf} 0 0 ${theme.spacing.half};
    font-size: ${theme.spacing.two};
  `}
`
